<template>
	<div class="mainContentBackground villageBackground unselectable">
		<div class="sea viewBackground" :style="{top: '0px', left: villageBackgroundLeft, right: 'auto', height: '1440px', transform: 'perspective(1000px) scale3d(1, 1, 1)', transformOrigin: '50% 50%', filter: 'blur(0px)', perspective: '1000px'}">
			<div class="modalWrapper statistics" style="opacity: 1; top: 400px; align-items: flex-start; justify-content: center; display: flex; width: 100%; height: 100%;">
				<div class="modal statistics">
					<div class="modalContent">
						<div class="modalDecoration"></div>
						<div class="functionPanel unselectable">
							<a class="closeWindow clickable" @click="$router.push('/township')">
								<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
									<i class="action_cancel_tiny_flat_black"></i>
								</div>
							</a>
						</div>
						<div>
							<div class="contentHeader unselectable">
								<h2 class="msAntiScroll drag" draggable="true">
									<span class="building"><span>Статистика</span></span>
								</h2>
							</div>
						</div>
						<div class="heightTransitionContent" :style="{maxHeight: maxHeightContent}">
							<div class="contentTabulation">
								<nav class="tabulation  maintab unselectable">
									<a class="tab clickable" :class="{active: tab == 'player', inactive: tab != 'player'}" @click="onToggleTab('player')">
										<div class="content">
											<span>Игрок</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'kingdoms', inactive: tab != 'kingdoms'}" @click="onToggleTab('kingdoms')">
										<div class="content">
											<span>Королевства</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'world', inactive: tab != 'world'}" @click="onToggleTab('world')">
										<div class="content">
											<span>Мир</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'worldWonder', inactive: tab != 'worldWonder'}" @click="onToggleTab('worldWonder')">
										<div class="content">
											<span>Чудо света</span>
										</div>
									</a>
								</nav>
								<div class="tabulationContent scrollable">
									<div class="scrollContentOuterWrapper">
										<div class="scrollContent" style="overflow-y: auto;" :style="{maxHeight: maxHeightInnerContent}">
											<div class="scrollContentInnerWrapper" style="width: auto;">
												<div class="statistics">
													<div class="loadedTab currentTab" v-if="tab == 'player'">
														<player />
													</div>
													<div class="loadedTab currentTab" v-if="tab == 'kingdoms'">
														<kingdoms />
													</div>
													<div class="loadedTab currentTab" v-if="tab == 'world'">
														<world />
													</div>
													<div class="loadedTab currentTab" v-if="tab == 'worldWonder'">
														<worldWonder />
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="window-overlay">
							
							<!--герой (при клике на аватарку)-->
							<player-profile-full-image v-if="gameModel.statistics.playerProfileFullImageShow" />
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Player from '@/components/pages/statistics/Player';
import Kingdoms from '@/components/pages/statistics/Kingdoms';
import World from '@/components/pages/statistics/World';
import WorldWonder from '@/components/pages/statistics/WorldWonder';

import PlayerProfileFullImage from '@/components/pages/statistics/windowOverlay/PlayerProfileFullImage';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Статистика | IW'});
	},
	data: () => ({
		maxHeightContent: '550px',
		maxHeightInnerContent: '530px',
		cancelHover: false,
		
		tab: 'player',
		showSearch: false,
		
		villageBackgroundLeft: '0px',
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_20.ogg');
				audio.play();
			}
		},
		onModalClose(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_7.ogg');
				audio.play();
			}
		},
		onToggleTab(tab, push = true){
			this.tab = tab;
			if(push) this.$router.push({query: {tab}});
			
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_8.ogg');
				audio.play();
			}
		},
		
		onResize(){
			//let leftpos = (window.innerWidth / 2) - (1920 / 2) - 70;
			let leftpos = (window.innerWidth / 2) - (1920 / 2);
			//console.log(window.innerWidth, leftpos);
			this.villageBackgroundLeft = leftpos+'px';
			
			let maxHeightContent = window.innerHeight - 325;
			maxHeightContent = (maxHeightContent < 550 ? 550 : maxHeightContent);
			this.maxHeightContent = maxHeightContent + 'px';
			this.maxHeightInnerContent = (maxHeightContent - 57 > 0 ? maxHeightContent - 57 : 0) + 'px';
		},
	},
	mounted(){
		this.onModalOpen();
		
		window.addEventListener('resize', this.onResize);
		this.onResize();
		
		if(this.$route.query.tab) this.tab = this.$route.query.tab;
		else this.$router.push({query: {tab: this.tab}});
	},
	unmounted(){
		this.onModalClose();
		
		window.removeEventListener('resize', this.onResize); 
	},
	beforeRouteUpdate(to, from, next){
		if(!to.query.tab) this.$router.push({query: {tab: 'player'}});
		else if(to.query.tab != this.tab) this.onToggleTab(to.query.tab, false);
		next();
	},
	created(){
		this.gameModel.buildingQueueShow = true;
	},
	components: {
		Player,
		Kingdoms,
		World,
		WorldWonder,
		
		PlayerProfileFullImage,
	},
}
</script>